<app-dropdown-select
  [options]="countryNames()"
  [placeholder]="'searchForACountry' | i18n"
  [label]="'country' | i18n"
  [selectedOption]="preselectedValue()"
  (optionSelected)="countrySelected($event)"
  [isRequired]="true"
  [panelRadius]="panelRadius"
  [detachPanel]="detachPanel"
>
</app-dropdown-select>
